module.exports = __webpack_public_path__ + "static/media/moblieview_img2.670aeaf6.png";